export * from './skeleton.module';
export * from './skeleton.component';
